// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.block-episodes {
  background-image: var(--episodes-bg-image);
  background-color: var(--episodes-bg-color);
  background-size: cover;
  background-position-x: center;
}
.block-episodes__title {
  color: var(--title-text-color) !important;
}
.block-episodes__sub-title {
  color: var(--sub-title-text-color) !important;
}
.block-episodes__sub-sub-title {
  color: var(--sub-sub-title-text-color) !important;
}
.block-episodes__episode-title, .block-episodes__collapse-episode-title, .block-episodes__collapse-episode-day, .block-episodes__collapse-episode-subtitle, .block-episodes__collapse .ant-collapse-arrow, .block-episodes__episode-subtitle {
  color: var(--episodes-text-color) !important;
}
.block-episodes__collapse-episode-day {
  padding-right: 15px;
}
.block-episodes__sub-title {
  font-size: 20px;
  margin-bottom: 5px;
}
.block-episodes__sub-sub-title {
  font-size: 16px;
  margin-bottom: 10px;
}
.block-episodes__collapse-header, .block-episodes__description {
  margin: 0 0 var(--episodes-titles-margin-bottom);
}
.block-episodes__collapse > .ant-collapse-item > .ant-collapse-header {
  padding: 0px;
}
.block-episodes__collapse > .ant-collapse-item:not(:last-child) {
  margin-bottom: 27px;
}
.block-episodes__collapse-episode-day {
  font-size: var(--episodes-dates-font-size);
  font-weight: bold;
}
.block-episodes__collapse > .ant-collapse-item > .ant-collapse-content > .ant-collapse-content-box {
  padding-left: 21px !important;
  padding-right: 21px !important;
}
.block-episodes__collapse-body {
  background-color: var(--episodes-accordion-bg-color);
  border-radius: var(--default-border-radius);
}
.block-episodes--list .block-episodes__collapse {
  width: 100%;
}
.block-episodes--list .block-episodes__collapse-header .live,
.block-episodes--list .block-episodes__collapse-header .vod {
  font-size: var(--episodes-dates-font-size);
  font-style: italic;
  margin: 0;
}
.block-episodes--list .block-episodes__collapse .ant-collapse-header .ant-collapse-arrow {
  top: 0;
  right: 40px;
  font-size: 16px;
}
.block-episodes--list .block-episodes__collapse > * > .ant-collapse-content {
  margin-bottom: 2rem;
}
.block-episodes__details-container {
  display: flex;
  flex-direction: column;
  gap: 2px;
  color: var(--episodes-text-color);
  font-size: var(--episodes-dates-font-size);
}
.block-episodes__full-page-container {
  position: relative;
}
@media (min-width: 1200px) {
  .block-episodes__episode-selector {
    position: absolute;
    right: 0;
    top: 10px;
    z-index: 3;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/blocks/Episodes/Episodes.scss"],"names":[],"mappings":"AAEA;EACI,0CAAA;EACA,0CAAA;EACA,sBAAA;EACA,6BAAA;AADJ;AAGI;EACI,yCAAA;AADR;AAII;EACI,6CAAA;AAFR;AAKI;EACI,iDAAA;AAHR;AAMI;EAMI,4CAAA;AATR;AAYI;EACI,mBAAA;AAVR;AAaI;EACI,eAAA;EACA,kBAAA;AAXR;AAcI;EACI,eAAA;EACA,mBAAA;AAZR;AAeI;EAEI,gDAAA;AAdR;AAiBI;EACI,YAAA;AAfR;AAkBI;EACI,mBAAA;AAhBR;AAmBI;EACI,0CAAA;EACA,iBAAA;AAjBR;AAoBI;EACI,6BAAA;EACA,8BAAA;AAlBR;AAqBI;EACI,oDAAA;EACA,2CAAA;AAnBR;AAuBQ;EACI,WAAA;AArBZ;AAwBgB;;EAEI,0CAAA;EACA,kBAAA;EACA,SAAA;AAtBpB;AA0BY;EACI,MAAA;EACA,WAAA;EACA,eAAA;AAxBhB;AA2BY;EACI,mBAAA;AAzBhB;AA8BI;EACI,aAAA;EACA,sBAAA;EACA,QAAA;EACA,iCAAA;EACA,0CAAA;AA5BR;AA+BI;EACI,kBAAA;AA7BR;AAiCQ;EADJ;IAEQ,kBAAA;IACA,QAAA;IACA,SAAA;IACA,UAAA;EA9BV;AACF","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
